module.exports = __webpack_public_path__ + "static/media/icnEmptyState.5e654420.svg";